export default {
  list: [],
  total: 0,
  totalSum: 0,
  selected: [],
  tableOptions: {
    groupBy: [],
    groupDesc: [],
    itemsPerPage: 25,
    multiSort: false,
    mustSort: false,
    page: 1,
    sortBy: ['date'],
    sortDesc: [true],
  },
  customers: {},
};
